import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';

export type PhaseTypeId = PhaseType['id'];

export type PhaseType = z.output<typeof phaseTypeSchema>;
export type PhaseTypeDTO = z.input<typeof phaseTypeSchema>;

export const phaseTypeSchema = z.object({
  color: z.string(),
  createdAt: isoDatetimeToDate,
  description: z.string().optional(),
  id: z.uuid(),
  name: z.string(),
  teamId: z.uuid(),
  updatedAt: isoDatetimeToDate,
});
